import { useMutation } from "react-query"
import axios from "axios";
import { POST } from "../../../../Services";

export const useEditarPokemon = () => {
  return useMutation(async (data) => {
    // Eliminar campos que no se deben enviar
    const excludeFields = ["created_at", "updated_at", "imagen"];
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([key]) => !excludeFields.includes(key))
    );

    const response = await POST(filteredData, "pokemon/editarPokemon");
    return response.data;
  });
};
